"use client";

import { useEffect, useState } from "react";

type ChromeRuntime = {
  lastError?: unknown;
  sendMessage: (
    extensionId: string | undefined,
    message: unknown,
    callback: (response: unknown) => void,
  ) => void;
};

type ChromeWindow = Window & { chrome?: { runtime?: ChromeRuntime } };

let detectedInstall: boolean | null = null;

export function useExtensionInstalled(): boolean | null {
  const [isInstalled, setIsInstalled] = useState<boolean | null>(detectedInstall);

  useEffect(() => {
    if (typeof window === "undefined" || detectedInstall !== null) {
      return;
    }

    const resolve = (value: boolean) => {
      detectedInstall = value;
      setIsInstalled(value);
    };

    const checkInstallation = () => {
      const runtime = (window as ChromeWindow).chrome?.runtime;
      if (!runtime) {
        resolve(false);
        return;
      }

      try {
        runtime.sendMessage(process.env.NEXT_PUBLIC_EXTENSION_ID, { ping: true }, () => {
          resolve(!runtime.lastError);
        });
      } catch {
        resolve(false);
      }
    };

    const timer = setTimeout(checkInstallation, 300);
    return () => clearTimeout(timer);
  }, []);

  return isInstalled;
}
